import React from 'react'
import './LoggedAdmin.css'
import dayjs from 'dayjs';
import fetchData from '../../function/fetchData'
import { useState, useEffect } from 'react'
import getActualDate from '../../function/getActualDate'
import AllDriversButtons from './adminComponents/AllDriversButtons'
import dateTimeDiferenceBetween from '../../function/dateTimeDiferenceBetween'
import MapsOfDrivers from './adminComponents/MapsOfDrivers'
import ShopList from './adminComponents/ShopList'
import { FaClock,FaCartShopping } from 'react-icons/fa6';
import { PiMapPinLineDuotone } from "react-icons/pi";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShop, faCreditCard, faMoneyBill, faEnvelope, faCalendar, faChartSimple } from '@fortawesome/free-solid-svg-icons';
import formatDateTime from '../../function/formatDateTime'
import Dropdown from 'react-bootstrap/Dropdown';
import { useNavigate } from 'react-router-dom';
import DriverRoadHistory from './DriverRoadHistory'
import Form from 'react-bootstrap/Form';

const checkDriverArrival = (destinationTime, timeDriverArrivedToClient) => {
  const destination = dayjs(destinationTime);
  const arrival = dayjs(timeDriverArrivedToClient);

  if (arrival.isAfter(destination)) {
      const delayMinutes = arrival.diff(destination, 'minute');
      return `Řidič přijel pozdě o ${delayMinutes} minut.`;
  } 
};



const LoggedAdmin = ({server, token, cetral }) => {
  const navigate = useNavigate();

  const [dispatch, setDispatch] = useState("SHOW_DATE")
  const [dateFrom, setDateFrom] =  useState(getActualDate('start'))
  const [dateTo, setDateTo] = useState(getActualDate('end'))
  const [listOfOrders , setListOfOrders] = useState([])
  const [listOfDrivers, setListOfDrivers] = useState([])
  const [listOfPrice, setListOfPrice] = useState([])
  const [selectedDriverId , setSelectedDriverId] = useState(null)
  const [countOfRegUsers, setCountOfRegUsers] = useState(0)
  const [showMap, setShowMap] = useState(false)
  const [showShop, setShowShop] = useState(false)
  const [showStatistics, setShowStatistics] = useState(false)
  // Přepínač
  const [checked, setChecked] = useState(false);
  const [totalPrice, setTotalPrice] = useState(0)
  const [totalKm, setTotalKm] = useState(0)
  const [lateTake, setLateTake] = useState(0)
  const [lateArrival, setLateArrival] = useState(0) 
  const [carLog, setCarLog] = useState([])


  // MODAL
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

   // Stav pro sledování vybraných záznamů
   const [selectedRecords, setSelectedRecords] = useState([]);

   // Funkce pro přepnutí zvolení/odznačení záznamu
   const handleSelectRecord = (id) => {
     if (selectedRecords.includes(id)) {
       setSelectedRecords(selectedRecords.filter(recordId => recordId !== id));
     } else {
       setSelectedRecords([...selectedRecords, id]);
     }
   };

  // Show MAP
  const showAdminMap = () => {
    setShowMap(true)
    localStorage.setItem('openMap', 1);
  }

  const getName = (id) => {
      const result = listOfDrivers.filter( one => {
        return one.id === id
      })
      return result[0]?.nick
  }

  // Zjistí zda před refreshem neměl otevřené okno map, pokud ano otevře znova
  useEffect(() => {
    // Funkce pro kontrolu Local Storage
    const checkLocalStorage = () => {
      // Získání hodnoty z Local Storage
      const openMapValue = parseInt( localStorage.getItem('openMap') );

      // Kontrola, zda je klíč 'openMap' uložený v Local Storage
      if (openMapValue && openMapValue === 1 ) {
          setShowMap(true)
      } 
    };
   
    checkLocalStorage();
  }, []); // 



  // Delete one
  const deleteOne = (id) => {
    const userInput = window.prompt('Zadejte heslo:', '');
    if(userInput == 'pavel'){
        fetchData(server + "api2/admin.php", {token: token, dispatch: "DELETE" , id: id})
        .then( (res) => {

          window.location.reload(true);
        } )
    } else {
      alert('zadali jste špatné heslo!')
    }
  }

    // Delete selected
    const deleteSelected = () => {
      const userInput = window.prompt('Zadejte heslo:', '');
      if(userInput == 'pavel'){
          fetchData(server + "api2/admin.php", {token: token, dispatch: "DELETE_SELECTED_GROUP" , selected: JSON.stringify(selectedRecords)})
          .then( (res) => {

            window.location.reload(true);
          } )
      } else {
        alert('zadali jste špatné heslo!')
      }
    }

  
// MAIN FETCH
useEffect(() => {
  const fetchDataAndSetState = async () => {
    try {
      const res = await fetchData(server + "api2/admin.php", {
        token: token,
        dispatch,
        dateFrom,
        dateTo,
      });

      if (selectedDriverId) {
        const newList = res.olders.filter((one) => {
          return parseInt(one.driver) === parseInt(selectedDriverId);
        });

        setListOfOrders(newList);
      } else {
        setListOfOrders(res.olders);
      }
      setCarLog(res.carLog);
      setListOfPrice(res.price);
      setListOfDrivers(res.drivers);
      setCountOfRegUsers(res.countOfRegUsers);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // Initial fetch
      fetchDataAndSetState();

      // Set up interval to fetch data every 30 seconds
      const intervalId = setInterval(fetchDataAndSetState, 10000);
    
      // Cleanup the interval on component unmount
      return () => clearInterval(intervalId);
  
  
}, [dispatch, dateFrom, dateTo, selectedDriverId, server, token]);
 
// spočítá cenu
  useEffect( ()=> {
        if(listOfOrders){
          let priceTemp = 0;
          let kmTemp = 0;
          let lateTake = 0;
          let lateArrival = 0;

          listOfOrders?.forEach( one => {
            const status = parseInt(one.status)
            if(status === 5){
                priceTemp += parseInt(one.price) 
                kmTemp +=  parseInt(one.tripDistance)  / 1000
                // Výpočet penále pro řidiče
                if(!one.bookTime  &&  one.timeDriverTake !== '0000-00-00 00:00:00' && dateTimeDiferenceBetween(one.date, one.timeDriverTake) > 3){
                    lateTake += 1
                } 
                if(parseInt( one.apology) === 1) {
                   lateArrival += 1
                }
            }
          }) 

          setTotalPrice(priceTemp)
          setTotalKm(Math.round( kmTemp) )
          setLateTake(lateTake)
          setLateArrival(lateArrival)
      }
  })

  // Mapa všech klient
  
  if(showMap || cetral){
      return (
            <MapsOfDrivers listOfDrivers={listOfDrivers} listOfOrders={listOfOrders} setShowMap={setShowMap} server={server} token={token}/>
      ) 
  }

  if(showStatistics){
    return (
          <DriverRoadHistory  setShowStatistics={setShowStatistics} server={server} token={token} datetimeStart={dateFrom} datetimeEnd={dateTo} selectedDriverId={selectedDriverId} getName={getName}/>
    ) 
}

  // SHop
  if(showShop){
    return  <ShopList  setShowShop={setShowShop} server={server} token={token}/>
  }


  return (
    <div className='LoggedAdminContainer'>
    
      <section className='LoggedAdminHeader'>
          <label htmlFor="">Od:</label>
          <input type="datetime-local" style={{width: 160}} value={dateFrom} onChange={ (e)=> setDateFrom(e.target.value)}/>
    
          <label htmlFor="">Do:</label>
          <input type="datetime-local" style={{width: 160}}  value={dateTo} onChange={ (e)=> setDateTo(e.target.value)}/>

     
          {/* <label htmlFor="">Partneři</label> 
          <Switch className="switch" onChange={handleChange} checked={checked} /> */}
    
           <Dropdown>
              <Dropdown.Toggle variant="success" id="dropdown-basic" size="sm">
                Řidiči
              </Dropdown.Toggle>

              <Dropdown.Menu>
              <AllDriversButtons 
                    listOfDrivers={listOfDrivers}  
                    selectedDriverId={selectedDriverId} 
                    setSelectedDriverId={setSelectedDriverId}
                />
              </Dropdown.Menu>
            </Dropdown>
      

          <div style={{display: 'flex', flexDirection: 'row', gap: 0}}> 
            <button className='mapButton' style={{background: 'white' , border: 'none', display: 'flex', gap: 10, padding: '2px 10px 2px 10px', borderRadius: 10}} onClick={showAdminMap}><PiMapPinLineDuotone size={27}/>Mapa</button>
            <button className='mapButton' style={{background: 'white' , border: 'none', display: 'flex', gap: 10, padding: '2px 10px 2px 10px', borderRadius: 10}} onClick={setShowShop}><FontAwesomeIcon icon={faShop} />Shop</button>
            <button className='mapButton' style={{background: 'white' , border: 'none', display: 'flex', gap: 10, padding: '2px 10px 2px 10px', borderRadius: 10}} onClick={()=> navigate('/admin/sichty')}><FontAwesomeIcon icon={faCalendar} />Šich a faktu.</button>
            <button className='mapButton' style={{background: 'white' , border: 'none', display: 'flex', gap: 10, padding: '2px 10px 2px 10px', borderRadius: 10}} onClick={()=> navigate('/admin/graf')}><FontAwesomeIcon icon={faChartSimple} />Graf</button>
            <button className='mapButton' style={{background: 'white' , border: 'none', display: 'flex', gap: 10, padding: '2px 10px 2px 10px', borderRadius: 10}} onClick={()=> navigate('/admin/smlouvy')}>Smlouvy</button>
              <button className='mapButton' style={{background: 'white' , border: 'none', display: 'flex', gap: 10, padding: '2px 10px 2px 10px', borderRadius: 10}} onClick={()=> navigate('/admin/users')}>Účty</button>
            <button className='mapButton' style={{background: 'white' , border: 'none', display: 'flex', gap: 10, padding: '2px 10px 2px 10px', borderRadius: 10, backgroundColor: 'rgb(144, 238, 144)'}} onClick={()=> setShowStatistics(true)} >Statistiky</button>
          </div>

      </section>

      {listOfOrders.length === 0 && <h1 className='statusTitle' >V tento den, žádná historie</h1>}

      <section className='container2'>
      {carLog && carLog.length > 0 && (
        <section className='carLog'>
            <div className="carLogTittle">
              <p>Řidiči ve službě dle data:</p>
            </div>
            {
              carLog.map( (one, key) => {
                  return <div className='carLogOneRow' key={key} style={one.type === "checkOut"? {background:'#ff9595'} : {background:'#c6fdb8'}}>
                    <h2>{getName(one.driver_id)}</h2>
                    <p>{formatDateTime(one.date)}</p>
                  </div>
              })
            }
        </section>
      )}        
          <section className='ListOfOrders' style={listOfOrders.length === 0 ? {display:'none'}:{}}>
          {
            !checked && listOfOrders.length > 0 && listOfOrders.map( (one) => {
              const status = parseInt(one.status)
              const review = parseInt(one.review)
              let price = parseInt(one.price)
              const driverArrivalInTime = checkDriverArrival(one.destinationTime, one.timeDriverArrivedToClient)
          
              return (
                <div className='oneOrderRaw' key={one.keyOfClient} >
                    <div className='left'>
                        <div className='oneColumn'>
                          <p>{one.date}</p>
                          <p>Řidič: {getName(one.driver)}</p>
                          <img src={one.img} alt="" />
                          {one.bookTime &&
                          <div>
                              <FaClock size={40} color={'blue'}/>
                              <p>{one.bookTime}</p>
                          </div>
                      
                          }
                          {one.shopOrder_id &&
                          <FaCartShopping size={40} color={'#078C7F'}/>
                          }
                          {one.driverOrder ? <img src={require('../../img/taxametr.png')}/> : ''}
                        </div>

                        <div className='oneColumn'>
                          <p>Start: {one.start}</p>
                          <p>Cíl: {one.destination}</p>
                          <p>Vzdálenost: {Math.round(one.tripDistance / 1000)} Km</p>
                          <p>Cena: {price} Kč {parseInt(one.promoPrice) > 0 ? ` ,PROMO: ${one.promoPrice} Kč` : ""} <FontAwesomeIcon icon={one.howToPay == 1 ? faMoneyBill :faCreditCard} color={one.howToPay == 1 ? 'green' :'blue'}/></p>
                          <p>Tel: {one.tel}</p>
                          {status === 1 && <p style={{color: "orange"}}>Přijatá nevyřízena</p>}
                          {status === 2 && <p>Přijatá zakázka řidičem</p>}
                          {status === 3 && <p>Řidič je na místě</p>}
                          {status === 5 && <p style={{color: "green"}}>Hotová zakázka</p>}
                          {status === 6 && <p style={{color: "red"}}>Storno řidičem</p>}
                          {status === 8 && <p style={{color: "red"}}>Storno zákazníkem do 2 min</p>}
                          {status === 10 && <p style={{color: "red"}}>Zákazník byl vykopnutý -už nikdy neobjedná!</p>}
                          {status === 15 && <p style={{color: "violet"}}>Zakázka vložena ručně řidičem</p>}
                          {one.note &&
                            <div style={{background: '#eee', padding: 3, display: 'flex', gap: 10, alignItems: 'center', borderRadius: 10, paddingLeft: 10}}>
                                <FontAwesomeIcon icon={faEnvelope} color={'grey'}/>
                                <h3>{one.note}</h3>
                            </div>
                          }
                          <p>{driverArrivalInTime}</p>
                          
                          {parseInt( one.apology) === 1 && <p style={{background: 'red', color: 'white', borderRadius: 10, padding:4}}>Řidič přijel po domluveném čase, byla poslána omluvenka</p>}
                          {!one.bookTime  &&  one.timeDriverTake !== '0000-00-00 00:00:00' && <p>Čas příjezdu co zvolil řidič: {dateTimeDiferenceBetween(one.date, one.destinationTime)- dateTimeDiferenceBetween(one.date, one.timeDriverTake)}  min</p> }
                        </div>
                    </div>
                    <div className='right'>
                        {review === 0 && <p>Nehodnotil</p>}
                        {review === 1 && <p>*</p>}
                        {review === 2 && <p>**</p>}
                        {review === 3 && <p>***</p>}
                        {review === 4 && <p>****</p>}
                        {review === 5 && <p>*****</p>}
                        <br />
                        {!one.bookTime  && one.timeDriverTake !== '0000-00-00 00:00:00' &&
                          <div>
                            <p>Přijal zakázku za:</p>
                            <p>{dateTimeDiferenceBetween(one.date, one.timeDriverTake)} min</p>
                          </div>
                        }
                        {one.bookTime &&
                          <p>na čas</p>
                        }
  
                        <p className='deleteBtn' onClick={ ()=> deleteOne(one.id) }>smazat</p>
                        
                        <input 
                          type="checkbox"
             
                        />
                         <Form.Check // prettier-ignore
                            type={'checkbox'}
                            id={one.id}            
                            checked={selectedRecords.includes(one.id)}
                            onChange={() => handleSelectRecord(one.id)}
                        />
                    </div>

                </div>
              )
            })
          }
          
        
        </section>
      </section>
      {
        selectedRecords.length > 0 ?
        <div className="bottomInfoPrice">
            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                Označeno celkem: {selectedRecords.length}
                <p className='deleteBtn' onClick={deleteSelected }>smazat označené</p>
            </div>
        </div>
        :
        <div className="bottomInfoPrice">
            <div>
                Celková cena: {totalPrice} Kč , Celkem najeto: {totalKm} Km
            </div>
            <div style={{display:'flex', gap: 10, alignItems: 'center'}}>
                Provize
                <div className='button' onClick={handleShow}>
                    5%: {Math.round(totalPrice * 0.05)} Kč
                </div>
                <div className='button' onClick={handleShow}>
                    10%: {Math.round(totalPrice * 0.10)} Kč
                </div>
                <div className='button' onClick={handleShow}>
                    15%: {Math.round(totalPrice * 0.15)} Kč
                </div>
                <div className='button' onClick={handleShow}>
                    20%: {Math.round(totalPrice * 0.20)} Kč
                </div>
                <div className='button' onClick={handleShow}>
                    po 3min: {lateTake}x
                </div>
                <div className='button' onClick={handleShow}>
                    Přijel pozdě: {lateArrival}x
                </div>
            </div>

            <div>
                Reg uživatelů: {countOfRegUsers}
            </div>
            
        </div>
      }

    </div>
  )
}

export default LoggedAdmin
